import hljs from 'highlight.js';
import CopyButtonPlugin from 'highlightjs-copy';

import 'highlightjs-copy/styles/highlightjs-copy.css';
import './styles.css';

const LANG_ALIASES = { sh:'bash', shell:'bash', zsh:'bash', node:'javascript', js:'javascript', html:'xml' };
const MARKER_RE = /^@@prigov_lang=([a-z0-9_+-]+)@@\n/i;

let inited = false;
let observer = null;
let themeLoaded = false;

function getConfig()
{
  const c = window.__prigovImCodeHighlight || {};
  return {
    enabled: c.enabled !== false,
    autoDetect: c.autoDetect !== false,
    maxBytes: Number.isFinite(c.maxBytes) ? c.maxBytes : 200000,
    theme: c.theme || 'stackoverflow-dark',
    themeBaseUrl: c.themeBaseUrl || '/bitrix/js/prigov/im/code-highlight/themes/',
  };
}

function loadCss(url)
{
  // BX.loadCSS есть почти всегда на страницах портала, но сделаем fallback
  if (window.BX && typeof BX.loadCSS === 'function')
  {
    BX.loadCSS(url);
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.head.appendChild(link);
}

function loadThemeOnce()
{
  if (themeLoaded) return;
  themeLoaded = true;

  const cfg = getConfig();
  const url = `${cfg.themeBaseUrl}${cfg.theme}.css`;
  loadCss(url);
}

export const PrigovCode = {
  init()
  {
    BX.ready(() => {
      const cfg = getConfig();
      if (!cfg.enabled) return;

      this.initHljsOnce();
      loadThemeOnce();

      this.highlightAllInDocument();
      this.enableObserver();
    });
  },

  initHljsOnce()
  {
    if (inited) return;
    inited = true;

    hljs.addPlugin(new CopyButtonPlugin({ lang: 'ru' }));
  },

  preprocessText(text)
  {
    const cfg = getConfig();
    if (!cfg.enabled) return text;
    if (!text.includes('[code=')) return text;

    const RE = /\[code=(?:"([^"]+)"|([^\]\s]+))\](<br\s*\/?>)?([\0-\uFFFF]*?)\[\/code\]/gim;

    return text.replace(RE, (full, qLang, plainLang, br1, rawCode) => {
      // защита по размеру: если слишком большой блок — не подсвечиваем вообще
      const size = (rawCode || '').length;
      if (cfg.maxBytes > 0 && size > cfg.maxBytes)
      {
        // просто превращаем в обычный [code] без маркера языка
        return `[code]${rawCode}[/code]`;
      }

      let lang = (qLang || plainLang || '').trim().toLowerCase();
      lang = LANG_ALIASES[lang] || lang;

      const marker = `@@prigov_lang=${lang || 'plaintext'}@@`;
      return `[code]${marker}\n${rawCode}[/code]`;
    });
  },

  highlightAllInDocument()
  {
    if (!document.body) return;
    this.applyToContainer(document.body);
  },

  enableObserver()
  {
    if (observer) return;

    observer = new MutationObserver((mutations) => {
      for (const m of mutations)
      {
        for (const node of m.addedNodes)
        {
          if (!(node instanceof HTMLElement)) continue;
          this.applyToContainer(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },

  applyToContainer(container)
  {
    const cfg = getConfig();
    if (!cfg.enabled) return;

    const blocks = container.querySelectorAll?.('.bx-im-message-content-code') || [];
    blocks.forEach((block) => this.processCodeBlock(block));
  },

  processCodeBlock(block)
  {
    const cfg = getConfig();
    if (!cfg.enabled) return;

    if (block.dataset.prigovHljsProcessed === '1') return;

    let raw = block.innerHTML || '';
    raw = raw
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#039;/gi, "'");

    const m = raw.match(MARKER_RE);
    if (!m) return;

    let lang = (m[1] || '').toLowerCase();
    lang = LANG_ALIASES[lang] || lang;

    const cleaned = raw.replace(MARKER_RE, '');

    // собираем pre/code
    const pre = document.createElement('pre');
    const code = document.createElement('code');

    if (lang) code.classList.add(`language-${lang}`);
    code.classList.add('hljs');
    code.textContent = cleaned;

    pre.appendChild(code);
    block.innerHTML = '';
    block.appendChild(pre);

    try
    {
      if (lang && hljs.getLanguage(lang))
      {
        hljs.highlightElement(code);
      }
      else
      {
        // если авто-детект выключен — просто plaintext
        if (!cfg.autoDetect)
        {
          // ничего не делаем: останется обычный текст в code
        }
        else
        {
          hljs.highlightElement(code);
        }
      }
    }
    catch (e) {}

    block.dataset.prigovHljsProcessed = '1';
  },
};
